<template>
  <q-table
    class="q-pb-sm text-weight-bold text-primary"
    flat
    bordered
    virtual-scroll
    style="height: 100%; border-color: #1976d2"
    table-header-class="text-grey"
    title-class="text-body1 text-bold"
    :rows-per-page-options="[0]"
    :columns="columns"
    :data="data.data"
    hide-pagination
    hide-no-data
    row-key="campaign_id"
  >

    <template v-slot:body="props">
      <q-tr
        :props="props"
        clickable
        @click="goToCampaign(props.row.campaign_id)"
        class="cursor-pointer"
      >
        <q-td v-for="col in props.cols" :key="col.name" :props="props">
          {{ col.value }}
        </q-td>
      </q-tr>
    </template>



  </q-table>
</template>

<script>
export default {
  name: 'ListCampaignsExclusive',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      columns: [
        {
          name: 'campaign_name',
          label: 'Campanhas Exclusivas',
          field: 'campaign_name',
          align: 'left',
          sortable: true
        },
        {
          name: 'affiliate_comission_value',
          label: 'Comissão',
          field: 'affiliate_comission_value',
          align: 'right',
          sortable: true,
          format: (val) => 'R$ ' + parseFloat(val).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
      ]
    };
  },

  methods: {
    goToCampaign(campaignId) {
      this.$router.push({ name: 'MyCampaigns', params: { myCampaignId: campaignId } });
    }
  }
};
</script>
